import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography
} from '@mui/material';

interface CustomMessageModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (message: string) => void;
  defaultMessage?: string;
}

const CustomMessageModal: React.FC<CustomMessageModalProps> = ({
  open,
  onClose,
  onSubmit,
  defaultMessage = "The work will start as we discussed."
}) => {
  const [customMessage, setCustomMessage] = useState(defaultMessage);

  const handleSubmit = () => {
    onSubmit(customMessage);
    onClose();
  };

  const handleReset = () => {
    setCustomMessage(defaultMessage);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold">
          Customize Thanks Letter Message
        </Typography>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Customize the message that will appear in the thanks letter:
          </Typography>
          
          <TextField
            fullWidth
            multiline
            rows={2}
            value={customMessage}
            onChange={(e) => setCustomMessage(e.target.value)}
            placeholder="Enter your custom message here..."
            variant="outlined"
            sx={{ mb: 2 }}
          />
          
          <Typography variant="caption" color="text.secondary">
            Default message: "{defaultMessage}"
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={handleReset} color="inherit">
          Reset to Default
        </Button>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Print Letter
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomMessageModal;